import * as React from 'react'
import PropTypes from 'prop-types'


export default class extends React.Component<any, any>{

    static propTypes = {
        if: PropTypes.any
    }


    render(){
        return this.props.if ? this.props.children : null
        
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/show.tsx